import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const statusStartRequest = () => {
  return {
    type: 'STATUS_START_REQUEST'
  };
};

export const statusEndRequest = () => {
  return {
    type: 'STATUS_END_REQUEST'
  };
};

export const getAllStatusSuccess = ({ data }) => {
  return {
    type: 'STATUS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllStatusError = error => {
  return {
    type: 'STATUS_GET_ALL_ERROR',
    payload: error
  };
};

export const addStatusSuccess = ({ data }) => {
  return {
    type: 'STATUS_ADD_SUCCESS',
    payload: data
  };
};

export const addStatusError = error => {
  return {
    type: 'STATUS_ADD_ERROR',
    payload: error
  };
};

export const editStatusSuccess = ({ data }) => {
  return {
    type: 'STATUS_EDIT_SUCCESS',
    payload: data
  };
};

export const editStatusError = error => {
  return {
    type: 'STATUS_EDIT_ERROR',
    payload: error
  };
};

export const removeStatusSuccess = id => {
  return {
    type: 'STATUS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeStatusError = error => {
  return {
    type: 'STATUS_REMOVE_ERROR',
    payload: error
  };
};

export const statusModifyStore = ({ data }) => {
  return {
    type: 'STATUS_MODIFY_STORE',
    payload: data
  };
};

export const addStatus = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(statusStartRequest());
      const response = await api().post('/api/status', data);
      dispatch(addStatusSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'status',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addStatusError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(statusEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllStatus = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(statusStartRequest());
      const response = await api().get('/api/status', { params });
      dispatch(getAllStatusSuccess(response));
    } catch (err) {
      dispatch(getAllStatusError(err));
    } finally {
      dispatch(statusEndRequest());
    }
  };
};

export const editStatus = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(statusEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(statusStartRequest());
      const id = data._id;
      const response = await api().put('/api/status/' + id, data);
      dispatch(editStatusSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'status',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/status'));
      }
    } catch (err) {
      dispatch(editStatusError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeStatus = id => {
  return async dispatch => {
    try {
      dispatch(statusStartRequest());
      await api().delete('/api/status/' + id);
      dispatch(removeStatusSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'status',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Status removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeStatusError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover status.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(statusEndRequest());
    }
  };
};

export const restoreStatus = data => {
  return async dispatch => {
    try {
      dispatch(statusStartRequest());
      const id = data._id;
      const response = await api().put('/api/status/' + id, data);
      dispatch(editStatusSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'status',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Status restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editStatusError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar status.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(statusEndRequest());
    }
  };
};
